import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSiteSettings } from '../context/SiteSettingsContext';
import { getConsent, onConsentChange, setConsent } from '../utils/consent';
import './ConsentBanner.css';

/**
 * A short cookie choice, shown only when the store asks for consent and the
 * visitor hasn't chosen yet. "Accept" lets Analytics and the Meta Pixel set
 * cookies; "Only necessary" keeps them off (Analytics still counts visits
 * without cookies through Google's consent mode).
 */
const ConsentBanner = () => {
  const { marketingConsentRequired, loaded } = useSiteSettings();
  const { t } = useTranslation();
  const [choice, setChoice] = useState(getConsent);

  useEffect(() => { setChoice(getConsent()); }, [marketingConsentRequired]);
  useEffect(() => onConsentChange((value) => setChoice(value)), []);

  if (!loaded || !marketingConsentRequired || choice) return null;
  const choose = (value) => { setConsent(value); setChoice(value); };

  return (
    <div className="consent-banner" role="region" aria-label={t('consent.label', 'Cookie choice')}>
      <p>
        {t('consent.text', 'We use cookies to understand how the shop is used and to show our products on Instagram and Facebook.')}{' '}
        <Link to="/cookies">{t('consent.more', 'Cookie policy')}</Link>
      </p>
      <div className="consent-banner__actions">
        <button type="button" className="consent-banner__secondary" onClick={() => choose('denied')}>{t('consent.decline', 'Only necessary')}</button>
        <button type="button" className="consent-banner__primary" onClick={() => choose('granted')}>{t('consent.accept', 'Accept')}</button>
      </div>
    </div>
  );
};

export default ConsentBanner;
